import i18n, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

/**
 * Supported languages for the application.
 */
export const SUPPORTED_LANGUAGES = ["en", "es", "sv"] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

/**
 * Language metadata for UI display.
 */
export const LANGUAGE_META: Record<
  SupportedLanguage,
  { name: string; nativeName: string }
> = {
  en: { name: "English", nativeName: "English" },
  es: { name: "Spanish", nativeName: "Español" },
  sv: { name: "Swedish", nativeName: "Svenska" },
};

/**
 * Initialize i18next with the given resources.
 * Resources should be collected from colocated translation files.
 */
export function initI18n(resources: Resource) {
  return i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      supportedLngs: SUPPORTED_LANGUAGES,

      // Namespace configuration
      ns: Object.keys(resources.en ?? {}),
      defaultNS: "common",

      interpolation: {
        escapeValue: false, // React already escapes
      },

      detection: {
        order: ["localStorage", "navigator"],
        caches: ["localStorage"],
        lookupLocalStorage: "flight-tools-language",
      },

      react: {
        useSuspense: false, // Better for SSR and initial load
      },
    });
}

export { i18n };
